import {Response} from "../../api/quotationApiClient";
import {strings} from "../../strings/strings";

export function handleAfterStepErrors(response: Response, callback: (Response) => void) {
    const errorCodes = [
        '8ea723f2-ec25-43bc-baf2-2af242030531',
        '2e459ed7-09e3-49ae-8e06-61899b6c341c',
        '66dd2a51-6b89-4d55-840d-3aa81d8f4123',
        '4fa1dd3c-245a-44f7-9225-a93907f6d632',
        '4fa1dd3c-245a-44f7-9225-a93907f6d635',
        '046423c0-8d01-40ff-b6f5-2ffb97cf660f'
    ];

    const uuidErrorPoint = response.errorResponse.detailText.search("[0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12}");
    if (uuidErrorPoint > 0) {
        if (errorCodes.includes(response.errorResponse.detailText.slice(uuidErrorPoint, uuidErrorPoint + 36))) {
            window.location.href = strings.refs.kontakty;
            return;
        }
    }

    callback(response);
}